import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { useState, useEffect } from "react";
import { FiEdit } from "react-icons/fi";
import { BsTrashFill } from "react-icons/bs";
import {RiForbid2Line} from "react-icons/ri"
import {AiFillCheckCircle} from "react-icons/ai"
import Swal from "sweetalert2";
import useAxios from "../../../services/useAxios";
import toast from "react-hot-toast";
import "rc-pagination/assets/index.css";

export default function SupplierProductItem({ data, setUpdater }) {

  // state for items input
  const [itemData, setItemData] = useState({});
  // request edit items
  const { loading, execute: updateProductApi } = useAxios(
    "api/Update_Avb_product_for_order"
  );
  // function change states
  const inputHandler = (object) => {
    setItemData((prev) => {
      return { ...prev, ...object };
    });
  };
  // function for edit items data
  const EditData = (type) => {
    let temp=""
    if(type=="edit") {temp=`price,${itemData.price}@@discount,${
      itemData.discount > 0 ? itemData.price - itemData.discount : 0
    }@@total_inventory_count,${itemData.total_inventory_count}`}
    else if(type=='delete') {temp='avb_pid_status,-1'}
    else if(type=='inactive') {temp='avb_pid_status,-2'}
    else if(type=='active'){ temp='avb_pid_status,0'}
    updateProductApi({
      conditions: `id/=/${itemData.id}`,
      keyvalues: temp,
    }).then((result) => {
      if (result.status == 1) {
        setUpdater((prev) => !prev);
        toast.success("ویرایش باموفقیت انجام شد.");
      } else
        toast.error("متاسفانه مشکلی پیش آمده است ، لطفا مجدد امتحان کنید.");
    });
  };
  // function for validation
  const validation = () => {
    let validate = true;
    if (
      itemData.price == "" ||
      itemData.price == undefined ||
      itemData.discount > itemData.price ||
      itemData.discount == undefined ||
      itemData.total_inventory_count == ""
    )
      validate = false;
    if (itemData.discount > itemData.price)
      toast.error("قیمت باتخفیف از قیمت نباید بیشتر باشد.");
    return validate;
  };
  // set items data to state in this component
  useEffect(() => {
    setItemData({
      product: data?.productInfo?.title,
      supplier: data?.supplierInfo?.title,
      price: data?.price,
      discount: data?.price - data?.discount,
      total_inventory_count: data?.total_inventory_count,
      id: data?.id,
      avb_pid_status:data?.avb_pid_status
    });
  }, [data]);
  console.log(itemData.avb_pid_status)
  return (
    <div className={`d-flex flex-wrap border rounded  supplier-product-item my-3 shadow ${itemData.avb_pid_status==0?"active":"inactive"}`} >
      <div className="w-1 border">
        <div className="title">نام محصول</div>
        <div className="m-1">{itemData?.product}</div>
      </div>
      <div className="w-1 border">
        <div className="title">فروشگاه</div>
        <div className="m-1">{itemData?.supplier}</div>
      </div>
      <div className="w-2 border">
        <div className="title">قیمت(تومان)</div>
        <input
          className=" form-control text-center m-1 "
          style={{ width: "93%" }}
          value={addCommas(itemData.price)}
          onChange={(e) => {
            if (!isNaN(removeCommas(e.target.value)))
              inputHandler({ price: removeCommas(e.target.value) });
          }}
        />
      </div>
      <div className="w-2 border ">
        <div className="title ">
          <div className="dots">قیمت با تخفیف (تومان)</div>
        </div>
        <input
          className="form-control text-center m-1"
          style={{ width: "93%" }}
          value={addCommas(itemData.discount)}
          onChange={(e) => {
            if (!isNaN(removeCommas(e.target.value)))
              inputHandler({ discount: removeCommas(e.target.value) });
          }}
        />
      </div>
      <div className="w-2 border">
        <div className="title">موجودی</div>
        <input
          className=" form-control text-center m-1"
          style={{ width: "93%" }}
          value={itemData.total_inventory_count}
          type="number"
          onChange={(e) => {
            if (!isNaN(removeCommas(e.target.value)))
              inputHandler({ total_inventory_count: e.target.value });
          }}
        />
      </div>
      <div className="w-2 border">
        <div className="title">عملیات</div>
       {itemData.avb_pid_status==0? 
       <div className="m-1">
          <FiEdit
            color="navy"
            style={{ cursor: "pointer", width: 20, height: 20 }}
            onClick={() => {
              if (validation()) {
                Swal.fire({
                  icon: "warning",
                  title: "آیا از ویرایش این محصول مطمئن هستید؟",
                  showCancelButton: true,
                  cancelButtonText: "<div className='txt-t1-m'>انصراف</div>",
                  confirmButtonText: "ویرایش",
                  cancelButtonColor: "#EF394E",
                  confirmButtonColor: "#439B58",
                }).then(({ isConfirmed }) => {
                  if (isConfirmed) {
                    EditData("edit");
                  }
                });
              }
            }}
          />
          <BsTrashFill
            color="tomato"
            style={{ cursor: "pointer", width: 20, height: 20 }}
            onClick={() => {
              Swal.fire({
                icon: "warning",
                title: "آیا از حذف این محصول مطمئن هستید؟",
                showCancelButton: true,
                cancelButtonText: "<div className='txt-t1-m'>انصراف</div>",
                confirmButtonText: "حذف",
                cancelButtonColor: "#EF394E",
                confirmButtonColor: "#439B58",
              }).then(({ isConfirmed }) => {
                if (isConfirmed) {
                  EditData("delete");
                }
              });
            }}
          />
          <RiForbid2Line  color="darkred" data-tip="غیرفعال"
            style={{ cursor: "pointer", width: 20, height: 20 }}
            onClick={() => {
              Swal.fire({
                icon: "warning",
                title: "آیا از غیرفعال کردن این محصول مطمئن هستید؟",
                showCancelButton: true,
                cancelButtonText: "<div className='txt-t1-m'>انصراف</div>",
                confirmButtonText: "غیرفعال",
                cancelButtonColor: "#EF394E",
                confirmButtonColor: "#439B58",
              }).then(({ isConfirmed }) => {
                if (isConfirmed) {
                  EditData("inactive");
                }
              });
            }}/>

         
          
        </div>:
        <div className="m-1"> <AiFillCheckCircle   color="success"
            style={{ cursor: "pointer", width: 20, height: 20 }}
            onClick={() => {
              if (validation()) {
                Swal.fire({
                  icon: "green",
                  title: "آیا از فعال کردن این محصول مطمئن هستید؟",
                  showCancelButton: true,
                  cancelButtonText: "<div className='txt-t1-m'>انصراف</div>",
                  confirmButtonText: "فعال",
                  cancelButtonColor: "#EF394E",
                  confirmButtonColor: "#439B58",
                }).then(({ isConfirmed }) => {
                  if (isConfirmed) {
                    EditData("active");
                  }
                });
              }
            }}/></div>}
       
      </div>
      
    </div>
  );
}
